import { useEffect, useMemo } from 'react';
import { useCommonStore, useSavedAgentsStore, useSearchStore } from "../../store/store";
import { views } from '../constants/savedAgents';
import { yearMonthDayDashDateFormat } from '../helpers/dataFormatters';
import { getIntervalLastDates } from '../components/helpers/savedAgents';
import { getSummaryPinnedConfig } from '../../common/components/table/agGrid/pinnedRowSettings';
import { modules } from '../../constants';

export const useSavedAgentsActivities = ({ savedAgentState }) => {
    const { selectedView } = savedAgentState;
    const {
        isAgentDataLoading,
        agentLists,
        timeIntervals,
    } = useCommonStore(state => ({
        isAgentDataLoading: state.isLoading,
        agentLists: state.agentLists,
        timeIntervals: state.timeIntervals,
    }));

    const {
        isLoading,
        getSavedAgentsActivities,
        activities,
        isLoadingActivities,
        savedAgentsSelectedList,
    } = useSavedAgentsStore(state => ({
        isLoading: state.isLoading,
        getSavedAgentsActivities: state.getSavedAgentsActivities,
        activities: state.activities,
        isLoadingActivities: state.isLoadingActivities,
        savedAgentsSelectedList: state.selectedListByModule[modules.proficiencyMetrics.savedAgents],
    }));

    const {
        selectedMls,
        summaryPinnedData,
        isLoadingSearchData,
        period,
        timePeriod,
    } = useSearchStore(state => ({
        selectedMls: state[state.selectedModule]?.selectedMls,
        summaryPinnedData: state[state.selectedModule]?.summaryPinnedData,
        isLoadingSearchData: state.isLoadingSearchData,
        period: state[state.selectedModule]?.loadedSearchCriteria?.timePeriod?.intervalType?.toString(),
        timePeriod: state[state.selectedModule]?.loadedSearchCriteria?.timePeriod,
    }));

    const mlsId = selectedMls?.mlsId?.toString();
    const periodDates = useMemo(() => {
        if (!timeIntervals?.length || !period) return null;
        return getIntervalLastDates(timeIntervals, period, timePeriod);
    }, [timeIntervals, period, timePeriod]);

    useEffect(() => {
        if (!savedAgentsSelectedList?.agentListId || selectedView?.value !== views.activity || !mlsId || !periodDates) return;
        getSavedAgentsActivities(mlsId, {
            from: yearMonthDayDashDateFormat(periodDates.from),
            to: yearMonthDayDashDateFormat(periodDates.to),
        });
    }, [selectedView?.value, mlsId, periodDates, getSavedAgentsActivities, savedAgentsSelectedList?.agentListId]);

    const summaryPinnedConfig = getSummaryPinnedConfig(selectedView.value);
    const shouldShowPinnedRow = [views.overview, views.listingProficiency].includes(selectedView.value);
    const isPageLoading = isLoading || isAgentDataLoading || isLoadingSearchData || isLoadingActivities;

    return {
        summaryPinnedConfig,
        summaryPinnedData,
        shouldShowPinnedRow,
        isPageLoading,
        activities,
        agentLists,
    };
};
